export default __webpack_public_path__ + "static/media/Honored Belt of the Plains.7b40a68d.jpg";